module.exports = __webpack_public_path__ + "img/register_mb_01.5368d226.png";